Namespace 'Customer.Dashboard'

class Customer.Dashboard.SummaryExportView extends Backbone.View
  template: JST['backbone/templates/customer/dashboard/summary/main/header/summary_export']

  render: ->
    @$el.html(@template())
    @$el.find('#export').on('click', @onExportClick)
    @$el.find('#logios-export').on('click', @onLogiosExportClick)
    @

  onExportClick: (event) =>
    @trigger('export_button:clicked')

  onLogiosExportClick: (event) =>
    @trigger('logios_export_button:clicked')
